export class AttributeState {
  static SUCCESS = 'tx-text-success';
  static FAIL = 'tx-text-danger';
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/model/attribute-state.ts